import React, { useEffect } from 'react';
import style from './content-types.module.scss';
import { contentTypes } from '../constants';
import { SetState } from '../../../types';
import { Content } from '../types';

type Props = {
	setContentType: SetState<Content['contentType']>;
	contentType: Content['contentType'];
};

export function ContentTypes(props: Props) {
	useEffect(() => {
		props.setContentType("text")
	}, [])

	return (
		<div className={style.contentTypes}>
			<h3>Content</h3>
			<div className={style.list}>
				{contentTypes.map((el) => {
					return (
						<button
							data-selected={el.value === props.contentType}
							onClick={() => {
								props.setContentType(el.value as any);
							}}
							className={style.contentType}
							key={el.value}
						>
							{el.label}
						</button>
					);
				})}
			</div>
		</div>
	);
}
